
require('../../../node_modules/jquery-youtube-background/src/jquery.youtubebackground.js');

var grVideoYoutube = require('./_grVideoYoutube');


(function (global, $) {
    'use strict';

    var home_slider = $('[gr-home-slider]');

    if ( !home_slider ) {
        return false;
    }

    var home_slider_autoplay = home_slider.attr('gr-home-slider-autoplay'),
        home_slider_autoplayspeed = home_slider.attr('gr-home-slider-autoplayspeed'),
        home_slider_videos = $('[gr-home-slider-video]');


    home_slider.slick({
        adaptiveHeight: true,
        dots: true,
        autoplay: home_slider_autoplay,
        autoplaySpeed: home_slider_autoplayspeed,
        appendArrows: $('.home-slider__slides')
    });

    if (home_slider_autoplay == "false" || home_slider_autoplay == false) {
        home_slider.slick('slickPause');
    }


    if (home_slider_videos &&  $(window).outerWidth() >= parseInt(window.groots.sassBreakpoints['lg'])) {


        // This code loads the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/player_api';
        tag.async = true;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Do something after the API code downloads (async)
        window.onYouTubePlayerAPIReady = function () {
            // instanciations
            var all = {};
            var index;
            var grVideos = document.querySelectorAll('[gr-video-youtube]');
            window.addEventListener('load', function () {
                if (grVideos.length) {
                    window.groots.grVideoYoutube = { instances: {} };
                    all = grVideos;
                    index = -1;
                    while (all[++index]) {
                        global.grVideoYoutube.instances[index] = new grVideoYoutube(all[index]);
                    }
                }
            }, false);
        };

        home_slider.on('init', function (event, slick) {
            var $currentSlide = slick.$slides.eq(0);
            var $video = $currentSlide.find('[gr-video-youtube]');
            handleAutoplay($video);
        });

        home_slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var $nextSlide = slick.$slides.eq(nextSlide);
            var $video = $nextSlide.find('[gr-video-youtube]');
            handleVideos($video);
            // handleAutoplay($video);
        });
    }


    function handleAutoplay($video) {
        if ($video.length) {
            setTimeout(function () {
                home_slider.slick('slickPause');
            }, 1);
        } else {
            setTimeout(function () {
                home_slider.slick('slickPlay');
            }, 1);
        }
    }

    // Helper to pause and play video on slide change
    function handleVideos($video) {
        if (!$video.length) {
            return;
        }

        var videos = window.groots.grVideoYoutube.instances;
        for (var key in videos) {
            var instance = videos[key];
            if (instance.selector === $video[0]) {
                if (!instance.ready) return;
                instance.replay();
            } else {
                if (!instance.ready) return;
                instance.pause();
            }
        }
    }

}(window.groots, jQuery, require('slick-carousel')));
